import { initializeApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

import { getAnalytics, setUserId, logEvent } from 'firebase/analytics';

import {
  FIREBASE_APIKEY,
  FIREBASE_APPID,
  FIREBASE_AUTHDOMAIN,
  FIREBASE_MEASUREMENTID,
  FIREBASE_MESSAGINGSENDERID,
  FIREBASE_PROJECTID,
  FIREBASE_STORAGEBUCKET,
  FIREBASE_RECAPTCH_APIKEY,
} from '@portal/config/env';
import { PageClass } from '@portal/enum/analytics';

const firebaseConfig = {
  apiKey: FIREBASE_APIKEY,
  authDomain: FIREBASE_AUTHDOMAIN,
  projectId: FIREBASE_PROJECTID,
  storageBucket: FIREBASE_STORAGEBUCKET,
  messagingSenderId: FIREBASE_MESSAGINGSENDERID,
  appId: FIREBASE_APPID,
  measurementId: FIREBASE_MEASUREMENTID,
  reCaptchaKey: FIREBASE_RECAPTCH_APIKEY,
};

export const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);

export const appCheck = firebaseConfig.reCaptchaKey
  ? initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(firebaseConfig.reCaptchaKey),
    })
  : null;

export const setAnalyticsUserId = (id: string | null) =>
  Promise.all([setUserId(analytics, id ?? '')]);

export const sendEvent = (
  eventType?: string,
  params?: {
    firebase_page: string;
    firebase_page_class: PageClass;
  }
) => logEvent(analytics, eventType ?? 'page_view', params);
